import React from 'react';
import { tokens as defaultTokens } from '../tokens';

export default function Wordmark({ tokens = defaultTokens, size = 11, amber = false }) {
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 8,
      fontFamily: tokens.fontMono, fontSize: size, letterSpacing: '0.3em',
      textTransform: 'uppercase', color: amber ? tokens.accent : tokens.textMid, fontWeight: 500,
    }}>
      <span style={{
        width: 6, height: 6, borderRadius: '50%', background: tokens.accent,
        boxShadow: `0 0 8px ${tokens.accent}`, animation: 'gl-breathe 3.5s ease-in-out infinite',
      }} />
      ghostlight
    </div>
  );
}
